{
  "comment": "M7 spec §16 (S15 owns; S20, S23, S24 read it): derelict reactivation. eligibility: the restorable share per region (seeded per M3 derelict POI), the class shares (habRing → hab, oreProcessor → refinery, depot → outpost, lab → clinic) and the exclusions (the Harrow, Column Nine, Okafor's lab before Mission 3, the guardian and hidden bases, the Gate Cluster). classes: the M4 template and the restart kit (salvaged components, goods). The refit costs refitMult × the template's L1 build cost and refitDaysMult × its build days. Lapse: dark after darkAfterDays without fuel cells, reverted after revertDays online days dark (a re-restart costs rerestartMult of the kit). Titles: keep-alive title.fuelCells every title.lapseDays online days; title.max convert at founding. Hand-over fees and standings per recipient; Holdfast markers by region; the Tethys registry challenge; Authority registration; bunker tetherstone; the Candle run; veinRig (S24): the AI tonnes a day of the Tethys fracture site a vein FR station handed to Tethys adds (× storyMult through the gate law); the T34 soak bounds. The depot and lab kits and the Candle run's credits are not in the spec: placeholders. Placeholders for the balance pass (M7 spec §15 item 4); tune freely. survey (S15): the Mk II+ scan tier, the FR-### designation range, the coolant-hazard share, Wrecker-squat shares and fence fees per region. harrow: FR-217's designation, survey text and refusal. holdfast.families: placeholder family names for the marker (naming pass). Kit components must be at the salvage.json bands.serviceable condition or better (SY-1). rushBonus (M8 MC-h4b, U14): a Rush-pattern salvaged component (provenance rush, D-502) that fills a kit slot also credits fuelCellsPerPart fuel cells toward the kit (never more than are still missing); a bonus only, never required; placeholder.",
  "eligibility": {
    "restorableShare": {
      "gate": 0.4,
      "mid": 0.4,
      "deep": 0.4,
      "rim": 0.4
    },
    "classShares": {
      "habRing": 0.35,
      "oreProcessor": 0.25,
      "depot": 0.3,
      "lab": 0.1
    },
    "exclusions": [
      "harrow",
      "column_nine",
      "okafor_lab_before_m3",
      "guardian_base",
      "hidden_bases",
      "gate_cluster"
    ]
  },
  "survey": {
    "minScannerTier": 2,
    "designation": {
      "min": 100,
      "max": 999
    },
    "coolantHazardShare": 0.6,
    "squatterShare": {
      "gate": 0,
      "mid": 0.2,
      "deep": 0.35,
      "rim": 0.5
    },
    "fenceFee": {
      "gate": 0,
      "mid": 3000,
      "deep": 5000,
      "rim": 8000
    }
  },
  "harrow": {
    "designation": 217,
    "surveyText": "reactor: warm; structure: occupied",
    "refusal": "Someone's already keeping this one alive."
  },
  "classes": {
    "habRing": {
      "template": "hab",
      "components": {
        "reactor": 1,
        "radiator": 2
      },
      "goods": {
        "fuel_cells": 20,
        "electronics": 6
      }
    },
    "oreProcessor": {
      "template": "refinery",
      "components": {
        "reactor": 2,
        "radiator": 1
      },
      "goods": {
        "fuel_cells": 20,
        "electronics": 6
      }
    },
    "depot": {
      "template": "outpost",
      "components": {
        "reactor": 1,
        "radiator": 1
      },
      "goods": {
        "fuel_cells": 20,
        "electronics": 6
      }
    },
    "lab": {
      "template": "clinic",
      "components": {
        "reactor": 1,
        "radiator": 1
      },
      "goods": {
        "fuel_cells": 20,
        "electronics": 6
      }
    }
  },
  "rushBonus": {
    "fuelCellsPerPart": 4
  },
  "refitMult": 0.2,
  "refitDaysMult": 0.5,
  "registrationFee": 10000,
  "influence": 30,
  "upkeep": {
    "fuelCellsPerDay": 1
  },
  "darkAfterDays": 2,
  "revertDays": 20,
  "rerestartMult": 0.5,
  "rebootRetryOnlineDays": 1,
  "title": {
    "lapseDays": 20,
    "fuelCells": 10,
    "max": 2
  },
  "handover": {
    "mutual": {
      "fee": 15000,
      "standing": 10
    },
    "holdfast": {
      "fee": 5000,
      "standing": 15,
      "markedStanding": 25
    },
    "authority": {
      "fee": 10000,
      "standing": 5
    },
    "meridian": {
      "fee": 20000,
      "standing": 5
    },
    "tethys": {
      "fee": 40000,
      "standing": 10,
      "holdfastStanding": -10,
      "markedHoldfastStanding": -25
    }
  },
  "holdfast": {
    "markerShare": {
      "gate": 0,
      "mid": 0.1,
      "deep": 0.3,
      "rim": 0.3,
      "enclave": 1
    },
    "holdfastShare": 0.25,
    "selfRestartStanding": -15,
    "familyStanding": 10,
    "familyMinStanding": 25,
    "families": [
      "Arden",
      "Kovač",
      "Mbeki",
      "Sorell",
      "Tanaka",
      "Oduya",
      "Lindqvist",
      "Haddad"
    ]
  },
  "tethysChallenge": {
    "chance": 0.5,
    "fromTier": 3,
    "veinHops": 2,
    "reviewOnlineDays": 5,
    "fee": 15000,
    "authorityStanding": 30
  },
  "authority": {
    "standingPerRegistration": 5,
    "pettyFeeMult": 2,
    "pettyWaitOnlineDays": 3
  },
  "bunker": {
    "minT": 3,
    "maxT": 10,
    "veinHops": 2,
    "fenceHoldfastStanding": 5
  },
  "veinRig": {
    "tonnesPerDay": 6
  },
  "candleRun": {
    "holdfastStanding": 3,
    "credits": 2000
  },
  "soak": {
    "flipRateMax": 1.25,
    "roiDays": [
      10,
      20
    ]
  }
}
